import React, {useState} from 'react';
import Order from '../order/Order';
import axios from 'axios';
import { notification, Alert } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const OrdersList = ({ orders, fetchList, setLoading }) => {
  const [api, contextHolder] = notification.useNotification();
  const [error, setError] = useState(false);

  const openNotification = () => {
    api.open({
      message: 'Ордер удален!',
      icon: <CheckCircleOutlined style={{ color: '#108ee9' }} />,
    });
  };
  
  const deleteOrder = async (order) => {
    setLoading(true);
    try { 
      await axios.delete(`http://146.190.45.185:8000/orders/${order.uuid}/`, {
        headers: {
          Authorization: `JWT ${window.localStorage.getItem('access')}`
        }
      });
      openNotification();
      await fetchList();
    } catch (error) {
      if (error.response.data.detail) {
        setError(error.response.data.detail);
      } else {
        setError('Ошибка при удалении, попробуйте позже'); 
      }
      setLoading(false);
    }
  };

  return (
    <div className='orders-list'>
      {contextHolder}
      {error && <div>
        <Alert
          message={error}
          type="error"
          showIcon
        />
        <br/>
      </div>}
      {orders.map(order => {
        return (
          <Order key={order.uuid} order={order} deleteOrder={deleteOrder} fetchList={fetchList} />
        )
      })}
    </div>
  )
};

export default OrdersList;